import React, {useState, useEffect, useRef} from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import { animations } from "react-animation";
import ImageViewerLoader from '@loaders/ImageViewerLoader';
import './ImageViewer.css';

ImageViewer.propTypes = {
    arrImages:PropTypes.array
};

function ImageViewer({arrImages, ...props}) {
    const curThumbRef = useRef(null);   
    const [curImg, setCurImg] = useState("");
    const [showSpinner, setShowSpinner] = useState(false);
    
    useEffect(() => {        
        document.body.addEventListener("hover", onHover);

        arrImages ? setCurImg(arrImages[0]) : setShowSpinner(true)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[arrImages]);
    
    const onHover = (event) => {        
        const currentImg = event.target.src;
        setCurImg(currentImg)
    }
   

    return (
        <div className='container-fluid' style={{backgroundColor:"white"}}>
            {!showSpinner ? (            
            <div className="container-detail-vwr" style={{ animation: animations.fadeIn }}>                
                <div className="vwr-main-image p-2 w-100 bd-highlight">
                    <div><img className='img-thumbnail w-100' src={curImg} alt={curImg} /></div>
                </div>               
                <div className="container-thumbs-vwr w-100">
                    <div className="d-flex justify-content-start flex-wrap bd-highlight">
                        {!isEmpty(arrImages) && arrImages.map((image, index) => {
                            return (
                              <div key={index} className="w-33">
                                <img
                                  key={index}
                                  id={"thumb" + index}
                                  ref={curThumbRef}
                                  className="img-thumbnail thumb-hover"
                                  src={image}
                                  alt="imagen"
                                  onMouseOver={(event)=>{onHover(event)}}
                                  style={{width:"247px", height:"203px"}}
                                />
                              </div>
                            );
                        })
                        }
                        <div className='w-33'>
                            <div className="badge text-muted text-wrap small">
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
             ):(
                <>
                    <blockquote className="blockquote">
                        <p>Cargando Album</p>
                    </blockquote>
                    <ImageViewerLoader animate={true} key={0} />
                </>
             )}

        </div>
    );
}

export default ImageViewer;